var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{style:({height: _vm.params.height + 'px', backgroundColor: _vm.params.backgroundColor})})])
}
var staticRenderFns = []

export { render, staticRenderFns }